/**
 *
 * Styles for ErrorPage
 *
 */

import styled from "styled-components";
import { breakpoints } from "root/libs/ui-styleguide/src";
import { DhlText } from "@dhl-official/react-library";
import Headline from "../../Texts/Headline";

export const PageWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: center;
  flex-direction: column;
  width: 265px;
  margin: 0 auto;
  padding-top: var(--dui-size-space-50x);
  padding-bottom: var(--dui-size-space-50x);

  @media screen and (min-width: ${breakpoints.tablet}) {
    padding-top: var(--dui-size-space-80x);
    padding-bottom: var(--dui-size-space-80x);
    align-items: center;
    flex-direction: row;
    width: auto;
  }
`;

export const IllustrationWrapper = styled.div`
  display: block;

  svg {
    width: 150px;
    height: 164px;
  }

  @media screen and (min-width: ${breakpoints.tablet}) {
    svg {
      width: 325px;
      height: 355px;
    }
  }

  @media screen and (min-width: ${breakpoints.desktop}) {
    svg {
      width: 410px;
      height: 447px;
    }
  }
`;

export const ContentWrapper = styled.div`
  display: block;
  width: 100%;

  @media screen and (min-width: ${breakpoints.tablet}) {
    margin-left: 75px;
    max-width: 325px;
  }

  @media screen and (min-width: ${breakpoints.desktop}) {
    margin-left: 125px;
    max-width: 410px;
  }
`;

export const StyledHeadline = styled(Headline)`
  padding-top: var(--gaq-size-space-23px);
  margin-bottom: 0;

  &.customFontSize {
    font-size: var(--gaq-size-font-31px);
    line-height: normal;
  }
`;

export const StyledSubline = styled(DhlText)`
  & > *:is(p, span) {
    margin-top: 0;
    margin-bottom: 18px;

    @media screen and (min-width: ${breakpoints.tablet}) {
      margin-bottom: 12px;
    }
  }

  &.customFontSize > *:is(p, span) {
    font-size: var(--gaq-size-font-21px);
    line-height: normal;

    @media screen and (min-width: ${breakpoints.tablet}) {
      font-size: var(--gaq-size-font-27px);
      line-height: normal;
    }

    @media screen and (min-width: ${breakpoints.desktop}) {
      font-size: var(--gaq-size-font-31px);
      line-height: normal;
    }
  }
`;

export const StyledText = styled(DhlText)`
  & > *:is(p, span) {
    margin-top: 0;
    margin-bottom: 0;
  }

  &.customFontSize > *:is(p, span) {
    font-size: var(--dui-size-font-md);
    line-height: normal;
  }
`;

export const LinkWrapper = styled.div`
  margin-top: 41px;
  display: inline-block;
`;
